import { render } from "./EditCompanyModal.vue?vue&type=template&id=31c4e115&scoped=true"
import script from "./EditCompanyModal.vue?vue&type=script&lang=js"
export * from "./EditCompanyModal.vue?vue&type=script&lang=js"

import "./EditCompanyModal.vue?vue&type=style&index=0&id=31c4e115&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31c4e115"]])

export default __exports__